"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

/**
 * Import box component displaying an icon, title, and children content.
 * Uses slot pattern for icon to allow flexible icon composition.
 */
var ImportBox = function ImportBox(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      children = _ref.children;
  return (0, _preact.h)("div", {
    className: "message-container"
  }, icon, (0, _preact.h)("div", {
    className: "upload-message-text"
  }, title), (0, _preact.h)("div", null, children));
};

var _default = ImportBox;
exports.default = _default;